import Grid from '@material-ui/core/Grid';
import BaseTable from 'components/Tables/BaseTable';
import { alertError } from 'ducks/alerts';
import { actions } from 'ducks/descriptorTypes';
import React from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreData } from 'selectors/generic';
import columns from 'utils/tables/columns/administration/descriptorTypes';

const Component = props => {
  const { descriptorTypes } = props;
  const { create, remove, update } = props;
  const tableRef = React.useRef(null);

  return (
    <Grid item xs={12}>
      <BaseTable
        ref={tableRef}
        columns={columns}
        data={descriptorTypes}
        onRowClick={() => null}
        editable={{
          onRowAdd: newData => create(newData),
          onRowUpdate: newData => update(newData.id, newData),
          onRowDelete: oldData => remove(oldData.id)
        }}
      />
    </Grid>
  )
};


const makeMapStateToProps = () => {
  const immutableDescriptorTypes = getImmutableStoreData('descriptorTypes');
  const mapStateToProps = (state, props) => ({
    descriptorTypes: immutableDescriptorTypes(state)
  })
  return mapStateToProps;
}

const mapDispatchToProps = dispatch => ({
  alertError: error => dispatch(alertError(error)),
  create: data => dispatch(actions.createPromise(data)),
  remove: id => dispatch(actions.removePromise(id)),
  update: (id, data) => dispatch(actions.updatePromise(id, data))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
